import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  (theme) => ({
    container: {
      display: "flex",
      justifyContent: "center",
      padding: ({ wrapperPadding }) => wrapperPadding || "24px 0px",
      width: ({ wrapperWidth }) => wrapperWidth,
    },
    loader: {
      width: ({ loaderWidth }) => loaderWidth,
    },
  }),
  { name: "CreatorTool" }
);

export default useStyles;
